/**
 * Sencify CTA-Boost
 * - Announcement Bar: Scroll-Expand ab 200px Scroll-Tiefe
 * - Sticky Blog-CTA: Erscheint ab 30% Scroll-Tiefe, Cookie-Close 24h
 */
(function () {
  'use strict';

  var SCROLL_THRESHOLD_ANNOUNCE = 200;
  var STICKY_SCROLL_PERCENT = 20;
  var CLOSE_COOKIE = 'sencify_sticky_closed';
  var CLOSE_DAYS = 1;

  // ========== Helpers ==========
  function setCookie(name, value, days) {
    var exp = new Date();
    exp.setTime(exp.getTime() + days * 86400000);
    document.cookie = name + '=' + value + '; expires=' + exp.toUTCString() + '; path=/; SameSite=Lax';
  }
  function getCookie(name) {
    var m = document.cookie.match('(^|;)\\s*' + name + '\\s*=\\s*([^;]+)');
    return m ? m.pop() : '';
  }

  // ========== Announcement Bar Scroll-Expand ==========
  function initAnnounceExpand() {
    var bar = document.querySelector('[data-sencify-announce]');
    if (!bar) return;
    if (bar.getAttribute('data-expand-enabled') !== 'true') return;
    if (!bar.querySelector('.sencify-announce__expand')) return;
    var expanded = false;
    var ticking = false;

    function update() {
      var y = window.scrollY || window.pageYOffset || 0;
      var shouldExpand = y > SCROLL_THRESHOLD_ANNOUNCE;
      if (shouldExpand !== expanded) {
        expanded = shouldExpand;
        bar.classList.toggle('sencify-announce--expanded', expanded);
        document.body.classList.toggle('sencify-announce-is-expanded', expanded);
      }
      ticking = false;
    }

    function onScroll() {
      if (!ticking) {
        window.requestAnimationFrame(update);
        ticking = true;
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    update();
  }

  // ========== Sticky Blog-CTA ==========
  function initStickyCta() {
    var cta = document.querySelector('[data-sencify-sticky]');
    if (!cta) return;
    if (getCookie(CLOSE_COOKIE) === '1') {
      cta.parentNode && cta.parentNode.removeChild(cta);
      return;
    }

    var closeBtn = cta.querySelector('[data-sencify-sticky-close]');
    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        cta.classList.remove('sencify-sticky-cta--visible');
        setCookie(CLOSE_COOKIE, '1', CLOSE_DAYS);
        setTimeout(function () {
          if (cta.parentNode) cta.parentNode.removeChild(cta);
        }, 320);
      });
    }

    var shown = false;
    var ticking = false;

    function check() {
      var doc = document.documentElement;
      var scrolled = (window.scrollY || window.pageYOffset || 0);
      var viewport = window.innerHeight || doc.clientHeight;
      var total = Math.max(doc.scrollHeight, doc.offsetHeight) - viewport;
      var pct = total > 0 ? (scrolled / total) * 100 : 0;

      if (!shown && pct >= STICKY_SCROLL_PERCENT) {
        shown = true;
        cta.classList.add('sencify-sticky-cta--visible');
      }
      ticking = false;
    }

    function onScroll() {
      if (!ticking) {
        window.requestAnimationFrame(check);
        ticking = true;
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    check();
  }

  function init() {
    initAnnounceExpand();
    initStickyCta();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
